import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Advanced from "./Advanced";
import NextSchedule from "./NextSchedule";
import { SCHEDULE_TYPES } from "App/componentsConfig";
import { forbidExtraProps } from "utils";
import { objectToArray } from "utils";
import {
  toggleScheduleType,
  toggleScheduleRetention,
  toggleScheduleDevice,
  toggleScheduleLoginDetails
} from "store/actions";
import StartTime from "./StartTime";
import { SPopupContext } from "../../../../../common/hoc/SlidingPopup/index";

function Schedule(props) {
  const { sPopupMethods } = React.useContext(SPopupContext);
  const currentType =
    props.enums?.ScheduleType?.props?.[props.scheduleInfo?.type?.current];

  const checkIfCustomWeekdays = () =>
    currentType.key === "CUSTOM" &&
    props.scheduleInfo?.weekDays.length === 5 &&
    [1, 2, 3, 4, 5].every(day => props.scheduleInfo?.weekDays.includes(day));

  //to show daily when 5 days are checked
  const [isDailyChecked, checkDaily] = React.useState(checkIfCustomWeekdays());

  // nothing to render until we have enums and schedule info
  if (!props.enums || !props.scheduleInfo || !currentType) {
    return null;
  }

  const handleDisableSchedule = () => {
    props.toggleScheduleType(
      currentType.key === "NO_SCHEDULE"
        ? props.scheduleInfo.type.past
        : props.enums.ScheduleType.NO_SCHEDULE
    );
  };

  return (
    <React.Fragment>
      <div className="schedule_backup_wrap schedule_backup_backupset disable_layer1">
        <div className="schedule_wrap2">
          <label className="switch">
            <span className="switch_notify">Backup Schedule</span>
            <input
              type="checkbox"
              checked={currentType.key !== "NO_SCHEDULE"}
              onChange={() => {
                if (currentType.key === "NO_SCHEDULE") {
                  handleDisableSchedule();
                } else {
                  sPopupMethods.openPopup("disableScheduleBackup", {
                    execute: () => {
                      sPopupMethods.closePopup();
                      handleDisableSchedule();
                    },
                    cancel: true,
                    secondExecute: () => {
                      sPopupMethods.closePopup();
                    }
                  });
                }
              }}
            />
            <span className="slider round" />
          </label>
        </div>
      </div>
      <div
        className={`schedule_backup_wrap transparent_layer_schedule ${
          currentType.key === "NO_SCHEDULE" ? "layer_active" : ""
        }`}
      >
        <div className="transparent_layer" />
        <div className="schedule_backup_selection">
          <div className="schedule_backup_selection_wrap">
            <div className="schedule_backup_tabs">
              <h4>Backup frequency</h4>
              <ul className="schedule_backup_ul">
                {objectToArray(SCHEDULE_TYPES).map((val, i) => {
                  const enumKey = props.enums.ScheduleType[val.key];

                  return (
                    <li key={i}>
                      <label className="radio_container">
                        <input
                          type="radio"
                          className="input_radio"
                          checked={
                            currentType.key !== "NO_SCHEDULE" &&
                            (checkIfCustomWeekdays() && isDailyChecked
                              ? props.enums.ScheduleType.DAILY
                              : checkIfCustomWeekdays() && !isDailyChecked
                              ? props.enums.ScheduleType.CUSTOM
                              : props.scheduleInfo.type?.current) === enumKey
                          }
                          name="initial_backup_radio"
                          value={i}
                          onChange={() => {
                            props.toggleScheduleType(enumKey);
                            if (enumKey === props.enums.ScheduleType.DAILY)
                              checkDaily(true);
                            else checkDaily(false);
                          }}
                          tabIndex={0}
                        />
                        <span className="radio_checkmark" />
                        <span className="fs_16">{val.name}</span>
                      </label>
                    </li>
                  );
                })}
              </ul>
            </div>
            <div className="schedule_backup_body">
              <div
                className={[
                  "sche_backup_item",
                  currentType.key === "NO_SCHEDULE"
                    ? "backup_" +
                      props.enums.ScheduleType.props[
                        props.scheduleInfo.type.past
                      ].name
                    : "backup_" + currentType.name,
                  "active"
                ].join(" ")}
              >
                {React.createElement(
                  SCHEDULE_TYPES[
                    currentType.key === "NO_SCHEDULE"
                      ? props.enums.ScheduleType.props[
                          props.scheduleInfo.type.past
                        ].key
                      : checkIfCustomWeekdays() && isDailyChecked
                      ? "DAILY"
                      : checkIfCustomWeekdays() && !isDailyChecked
                      ? "CUSTOM"
                      : currentType.key
                  ].component,
                  {
                    checkDaily
                  }
                )}
              </div>
            </div>
          </div>
          <div
            className={`transparent_layer_schedule ${
              currentType.key === "INTERVAL" ? "layer_active" : ""
            }`}
          >
            <div className="schedule_backup_timer">
              <div className="transparent_layer" />
              <StartTime />
            </div>
          </div>
        </div>
        <NextSchedule
          scheduleInfo={props.scheduleInfo}
          enums={props.enums}
          clients={props.clients}
          clientDetails={props.clientDetails}
        />
      </div>
      <Advanced
        currentTypeKey={currentType.key}
        scheduleInfo={props.scheduleInfo}
        toggleScheduleRetention={props.toggleScheduleRetention}
        toggleScheduleLoginDetails={props.toggleScheduleLoginDetails}
        toggleScheduleDevice={props.toggleScheduleDevice}
        backupProgress={
          props.clients[props.clientDetails.clientUUID].status.progress.value
            .status
        }
        imageRestoreProgress={
          props.clients[props.clientDetails.clientUUID].restoreStatus &&
          !(
            "totalFiles" in
            props.clients[props.clientDetails.clientUUID].restoreStatus
          )
        }
      />
    </React.Fragment>
  );
}

Schedule.propTypes = forbidExtraProps(
  {
    scheduleInfo: PropTypes.shape({
      type: PropTypes.shape({
        current: PropTypes.oneOf([0, 1, 2, 3, 4]).isRequired
      }).isRequired,
      startTime: PropTypes.shape({
        value: PropTypes.number.isRequired
      }).isRequired,
      weekDays: PropTypes.arrayOf(PropTypes.number).isRequired,
      advanced: PropTypes.shape({
        onWakeup: PropTypes.shape({
          checked: PropTypes.bool.isRequired,
          password: PropTypes.string,
          userName: PropTypes.string
        }),
        performShutdown: PropTypes.bool.isRequired,
        preventSleep: PropTypes.bool.isRequired,
        runMissed: PropTypes.bool.isRequired,
        startBackupImmediately: PropTypes.bool.isRequired
      }).isRequired
    }).isRequired
  },
  [
    "enums",
    "toggleScheduleType",
    "toggleScheduleRetention",
    "toggleScheduleDevice",
    "toggleScheduleLoginDetails",
    "clients",
    "clientDetails"
  ]
);

function mapStateToProps(state) {
  return {
    scheduleInfo: state.backupSettings.scheduleInfo,
    enums: state.common.enums,
    clients: state.dashboard.clients.list,
    clientDetails: state.backupSettings.clientDetails
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      toggleScheduleType,
      toggleScheduleRetention,
      toggleScheduleDevice,
      toggleScheduleLoginDetails
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Schedule);
